import { createBrowserClient } from "@supabase/ssr";

export type Database = {
  public: {
    Tables: {
      menus: {
        Row: {
          id: string;
          created_at: string;
          user_id: string;
          original_image_url: string;
          translated_menu_url: string;
          qr_code_url: string;
          status: "processing" | "completed" | "failed";
          original_text: string | null;
          translated_text: Record<string, string> | null;
          is_published?: boolean;
          media_assets?: Record<string, unknown>[] | null;
          default_media_id?: string | null;
          structured_data?: {
            title?: {
              japanese?: string;
              english?: string;
            };
            [key: string]: unknown;
          } | null;
        };
        Insert: Omit<
          Database["public"]["Tables"]["menus"]["Row"],
          "id" | "created_at"
        >;
        Update: Partial<
          Omit<Database["public"]["Tables"]["menus"]["Row"], "id">
        >;
      };
      users: {
        Row: {
          id: string;
          created_at: string;
          email: string;
          restaurant_name: string | null;
          subscription_status: "free" | "premium";
        };
        Insert: Omit<
          Database["public"]["Tables"]["users"]["Row"],
          "id" | "created_at"
        >;
        Update: Partial<
          Omit<Database["public"]["Tables"]["users"]["Row"], "id">
        >;
      };
    };
  };
};

// Create a singleton instance to prevent multiple client instantiations
let supabaseClient: ReturnType<typeof createBrowserClient<Database>> | null = null;

export function createClient() {
  if (supabaseClient) {
    return supabaseClient;
  }

  supabaseClient = createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
  
  return supabaseClient;
}
